import { useEffect, useState } from "react";

const getImagePaths = (basePath, category, extension) => {
  return category.map((imageName) => `${basePath}/${imageName}.${extension}`);
};

export default function useImagesSrc() {
  const basePath = "../assets";

  const chooseTarget = getImagePaths(`${basePath}/track_target`, [
    "friend",
    "grandparent",
    "kid",
    "other",
    "partner",
    "sibling",
  ], "png");

  const chooseLocation = getImagePaths(`${basePath}/which_locations`, [
    "bar_restaurant",
    "friends",
    "hobby_classes",
    "home",
    "medical_institution",
    "other",
    "school",
    "unknown_locations",
    "work",
  ], "png");

  const chooseReason = getImagePaths(`${basePath}/primary_reason`, [
    "doubt",
    "keep_kid_away",
    "match_friend_location",
    "other",
    "prevent_lost",
    "safety_concerns",
    "stay_connected",
  ], "png");

  const chooseTime = getImagePaths(`${basePath}/how_often`, [
    "every_day",
    "every_hour",
    "never",
    "once_a_week",
    "rarely",
  ], "png");

  const chooseFrequency = getImagePaths(`${basePath}/how_frequently`, [
    "every_fifteen_minutes",
    "every_five_minutes",
    "every_hour",
    "other",
    "real_time",
  ], "png");

  const chooseLocationType = getImagePaths(`${basePath}/types_of_locations`, [
    "areas_high_crime",
    "bars_casinos",
    "distant_place_from_home",
    "easily_lost_locations",
    "ex_house",
    "friends_homes",
    "high_risk_injury",
    "hotels",
    "nightclubs",
    "other",
    "shopping_malls",
    "unknown_locations",
    "unsafe_parks_playgrounds",
    "unsupervised_public_areas",
  ], "png");

  const chooseQuantity = getImagePaths(`${basePath}/how_many`, [
    "one_two",
    "six_ten",
    "ten_plus",
    "three_five",
  ], "png");

  const chooseFeature = getImagePaths(`${basePath}/which_features`, [
    "all_the_above",
    "other",
    "place_alerts",
    "real_time_location_tracking",
    "panic_button",
    "check_in",
    "location_history"
  ], "png");

  const aboutUsImages = getImagePaths(
    `${basePath}/massmedia`,
    [
      "bild",
      "die-welt",
      "quote",
      "rtl",
      "spiegel-online",
      "tc-logo",
      "tech-crunch",
      "wired",
    ],
    "png"
  )

  const getInitImagesSources = () => {
    return {
      "about": aboutUsImages,
      "choose-target": chooseTarget,
      "choose-location": chooseLocation,
      "choose-reason": chooseReason,
      "choose-time": chooseTime,
      "choose-frequency": chooseFrequency,
      "choose-location-type": chooseLocationType,
      "choose-quantity": chooseQuantity,
      "choose-feature": chooseFeature,
      "explore-solutions": `${basePath}/screens/explore-solutions.png`,
      "real-time-location": `${basePath}/screens/real-time-location.png`,
      "place-alerts": `${basePath}/screens/place-alerts.png`,
      "check-in": `${basePath}/screens/check-in.png`,
      "location-history": `${basePath}/screens/location-history.png`,
      "panic-button": `${basePath}/screens/panic-button.png`,
      "platform-support": `${basePath}/screens/platform-support.png`,
    };
  };

  const [imagesSources, setImagesSources] = useState(getInitImagesSources());

  useEffect(() => {
    const imagesSources = getInitImagesSources();
    setImagesSources(imagesSources);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    imagesSources,
  };
}
